import * as Types from "./statusPage.types";

export const unpackAllPagesToOverallStatus = (
  data: Array<Types.StatusPageSingle>
) => ({ status: data[0].status });
